
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground, PropsTable } from 'docz';
import { useState } from 'react';
import ButtonGroup from "../shared/components/ButtonGroup.js"
import Button from '../shared/components/Button.js'
import '../shared/components/Button.css'
import "../shared/css/index.css"
import "../shared/components/ButtonGroup.css"

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"buttongroup"}}>{`ButtonGroup`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const [direction, setDirection] = useState(\'horizontal\')\n  const [orientation, setOrientation] = useState(\'center\')\n  const directions = [\'vertical\', \'horizontal\']\n  const orientations = [\'left\', \'right\', \'center\']\n\n  return (\n    <div>\n      <div>\n        <label>Direction</label>\n        <select\n          value={direction}\n          onChange={e => {\n            setDirection(e.target.value)\n          }}\n        >\n          {directions.map(directionVal => (\n            <option value={directionVal}>{directionVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Orientation</label>\n        <select\n          value={orientation}\n          onChange={e => {\n            setOrientation(e.target.value)\n          }}\n        >\n          {orientations.map(orientationVal => (\n            <option value={orientationVal}>{orientationVal}</option>\n          ))}\n        </select>\n      </div>\n      <ButtonGroup direction={direction} orientation={orientation}>\n        <Button>Confirmar</Button>\n        <Button action=\"destructive\" hierarchy=\"tertiary\">\n          Cancelar\n        </Button>\n      </ButtonGroup>\n    </div>\n  )\n}'} __scope={{props: this ? this.props : props,useState,ButtonGroup,Button}}>
  { () => {
    const [direction, setDirection] = useState("horizontal");
    const [orientation, setOrientation] = useState("center");
const directions = ["vertical", "horizontal"];
const orientations = ["left", "right", "center"];

return (
  <div>
    <div>
      <label>Direction</label>
      <select value={direction} onChange={
        (e) => {
          setDirection(e.target.value)
        }
      }>
        {directions.map(directionVal => <option value={directionVal}>{directionVal}</option>)}
      </select>
    </div>
    <div>
      <label>Orientation</label>
      <select value={orientation} onChange={
        (e) => {
          setOrientation(e.target.value)
        }
      }>
        {orientations.map(orientationVal => <option value={orientationVal}>{orientationVal}</option>)}
      </select>
    </div>
    <ButtonGroup direction={direction} orientation={orientation}>
      <Button>Confirmar</Button>
      <Button action="destructive" hierarchy="tertiary">Cancelar</Button>
    </ButtonGroup>
  </div>
)
  } }
</Playground>
<PropsTable of={ButtonGroup} />
           </MDXTag>
  }
}
  